var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "riDocumentLookupField" }, [
    _c(
      "a",
      {
        staticClass: "ridlfPicker",
        attrs: { href: "#" },
        on: {
          click: function($event) {
            $event.preventDefault()
            _vm.openPicker()
          }
        }
      },
      [
        _c(
          "svg",
          {
            staticStyle: { width: "24px", height: "24px" },
            attrs: { viewBox: "0 0 24 24" }
          },
          [
            _c("path", {
              attrs: {
                fill: "currentColor",
                d:
                  "M3,5H9V11H3V5M5,7V9H7V7H5M11,7H21V9H11V7M11,15H21V17H11V15M5,20L1.5,16.5L2.91,15.09L5,17.17L9.59,12.59L11,14L5,20Z"
              }
            })
          ]
        ),
        _vm._v(" "),
        _c("span", [_vm._v("Dokument auswählen")])
      ]
    ),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "riDocumentLookup" },
      _vm._l(_vm.items, function(item) {
        return _c(
          "li",
          { key: item.ServerRelativeUrl, class: { ridlfError: !item.ID } },
          [
            _c(
              "a",
              { attrs: { href: item.ServerRelativeUrl, target: "_blank" } },
              [_vm._v(_vm._s(item.Title))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "ridlfActions" }, [
              _c(
                "div",
                {
                  attrs: { title: "Hoch" },
                  on: {
                    click: function($event) {
                      _vm.move(item, -1)
                    }
                  }
                },
                [
                  _c(
                    "svg",
                    {
                      staticStyle: { width: "24px", height: "24px" },
                      attrs: { viewBox: "0 0 24 24" }
                    },
                    [
                      _c("path", {
                        attrs: {
                          fill: "currentColor",
                          d: "M15,20H9V12H4.16L12,4.16L19.84,12H15V20Z"
                        }
                      })
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  attrs: { title: "Runter" },
                  on: {
                    click: function($event) {
                      _vm.move(item, +1)
                    }
                  }
                },
                [
                  _c(
                    "svg",
                    {
                      staticStyle: { width: "24px", height: "24px" },
                      attrs: { viewBox: "0 0 24 24" }
                    },
                    [
                      _c("path", {
                        attrs: {
                          fill: "currentColor",
                          d: "M9,4H15V12H19.84L12,19.84L4.16,12H9V4Z"
                        }
                      })
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  attrs: { title: "Entfernen" },
                  on: {
                    click: function($event) {
                      _vm.remove(item)
                    }
                  }
                },
                [
                  _c(
                    "svg",
                    {
                      staticStyle: { width: "24px", height: "24px" },
                      attrs: { viewBox: "0 0 24 24" }
                    },
                    [
                      _c("path", {
                        attrs: {
                          fill: "currentColor",
                          d:
                            "M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z"
                        }
                      })
                    ]
                  )
                ]
              )
            ])
          ]
        )
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }